// extracted by mini-css-extract-plugin
module.exports = {"container":"EditItem_container__NleNS","name":"EditItem_name__3aLVX"};